"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _emotion = require("emotion");

var _emotionTheming = require("emotion-theming");

var s = {
  separator: function separator(theme) {
    return (
      /*#__PURE__*/
      (0, _emotion.css)("margin:0px 5px;color:", theme.color.dark.iron, ";")
    );
  }
};

function Separator(_ref) {
  var className = _ref.className,
      theme = _ref.theme;
  return _react.default.createElement("span", {
    className: (0, _classnames.default)(s.separator(theme), className)
  }, "\u2022");
}

var _default = (0, _emotionTheming.withTheme)(Separator);

exports.default = _default;